import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackHintQuestionClick } from './tracking';
import { setEditableMessage } from '../../actions/chat/actions';
import { HintQuestion, HintQuestionsLayout } from '../../components/HintQuestions';
import { currentOpenChatSelector } from '../../selectors';
import { availableDatesSelector } from '../../selectors/availableDatesSelector';
import { hintQuestionsIsVisibleSelector, hintQuestionsSelector } from '../../selectors/hintQuestionsSelector';
import { TChatHint, EAnalyticsKey } from '../../types/chatHint';
import { formatDate } from '../../utils/formatDate';

interface IHintQuestionsContainerProps {
  onHintQuestionChange(analyticsKey: EAnalyticsKey): void;
}

export const HintQuestionsContainer: React.VFC<IHintQuestionsContainerProps> = ({ onHintQuestionChange }) => {
  const dispatch = useDispatch();
  const questions = useSelector(hintQuestionsSelector);
  const hintQuestionsIsVisible = useSelector(hintQuestionsIsVisibleSelector);
  const currentChat = useSelector(currentOpenChatSelector);
  const { checkin, checkout } = useSelector(availableDatesSelector);

  const onQuestionClick = React.useCallback(
    (text: string) => {
      if (!currentChat) {
        return;
      }

      const { offer } = currentChat;
      const question = questions.find(({ buttonText }) => buttonText === text) as TChatHint;
      const { analyticsKey } = question;
      let { messageText } = question;

      const formatCheckin = checkin ? formatDate(checkin) : '';
      const formatCheckout = checkout ? formatDate(checkout) : '';

      if (analyticsKey === EAnalyticsKey.AvailableDates && formatCheckin && formatCheckout) {
        messageText = messageText.replace('…', formatCheckin).replace('…', formatCheckout);
      }

      dispatch(setEditableMessage({ chatId: currentChat.chatId, text: messageText }));
      trackHintQuestionClick(offer, analyticsKey);
      onHintQuestionChange(analyticsKey);
    },
    [currentChat, questions, checkin, checkout, dispatch, onHintQuestionChange],
  );

  const hintQuestions = questions.map(({ buttonText }, index) => (
    <HintQuestion text={buttonText} onClick={onQuestionClick} key={index} />
  ));

  return questions && hintQuestionsIsVisible ? <HintQuestionsLayout>{hintQuestions}</HintQuestionsLayout> : null;
};
